
const m = window.require("discourse/widgets/post");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
